export default "__VITE_ASSET__ucrNYGL4__"